import { render, staticRenderFns } from "./WaitStatusDialog.vue?vue&type=template&id=06977c7a&scoped=true"
import script from "./WaitStatusDialog.vue?vue&type=script&lang=js"
export * from "./WaitStatusDialog.vue?vue&type=script&lang=js"
import style0 from "./WaitStatusDialog.vue?vue&type=style&index=0&id=06977c7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06977c7a",
  null
  
)

export default component.exports